export default __webpack_public_path__ + "static/media/Store Logo.fd5632d1.png";